import { __awaiter, __generator } from "tslib";
/**
 * Creates a "cache-first" persistence data flow that can be parameterized.
 * @param readNetwork - A callback that returns a Promise that returns the result from the network. Will be persisted once it arrives successfully.
 * @param readPersistence - A callback that returns a Promise that will read from persistence and return the stored data.
 * @param writeToPersistence - A callback that returns a Promise that accepts data arriving from the network, and will resolve once completed persisting the data.
 */
export function createCacheFirstOperation(readNetwork, readPersistence, writeToPersistence) {
    return __awaiter(this, void 0, void 0, function () {
        var cachedData, _a, networkRead;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, readPersistence()];
                case 1:
                    cachedData = _b.sent();
                    if (cachedData) {
                        return [2 /*return*/, {
                                result: cachedData,
                                fromPersistence: true,
                            }];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    _a = _b.sent();
                    return [3 /*break*/, 3];
                case 3: return [4 /*yield*/, readNetwork()];
                case 4:
                    networkRead = _b.sent();
                    writeToPersistence(networkRead);
                    return [2 /*return*/, { result: networkRead, fromPersistence: false }];
            }
        });
    });
}
//# sourceMappingURL=createCacheFirstOperation.js.map